import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { IUser } from '../model/interface/IUser';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private router: Router) {}

  private setUser(user: IUser): void {
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  public redirectTo(guard: boolean): void {
    if (guard) {
      if (this.verifyUser()) {
        if (this.getCurrentRoleUser().includes('readResult')) {
          this.router.navigate(['results', 1]);
        } else if (this.getCurrentRoleUser().includes('startTest')) {
          this.router.navigate(['instructions']);
        }
      } else {
        this.router.navigate(['register']);
      }
    } else {
      const n = sessionStorage.getItem('numItem') || null;
      if (n != null) {
        this.router.navigate(['test/item', n]);
      }
    }
  }

  public verifyUser(): boolean {
    return !this.getCurrentUser() ? false : true;
  }

  public getCurrentRoleUser(): string[] {
    return this.getCurrentUser().role;
  }

  public registerUser(user: IUser): void {
    this.setUser(this.organizeTextUser(user));
  }

  public changeRoleUser(role: string): void {
    let user = this.getCurrentUser();
    user.role = [role];
    sessionStorage.setItem('user', JSON.stringify(user));
  }

  public getCurrentUser(): IUser | null {
    return JSON.parse(sessionStorage.getItem('user'));
  }

  public deleteUser(): void {
    sessionStorage.removeItem('user');
  }

  private organizeTextUser(user: IUser): IUser {
    const capitalizar = (str: string): string => {
      const value = str.toLowerCase();
      return value.charAt(0).toUpperCase() + value.slice(1);
    };
    for (const key in user) {
      if (
        (typeof user[key] == 'string' && key === 'nombre') ||
        key === 'apellido' ||
        key === 'programa_academico'
      ) {
        const value: string[] = user[key].split(' ');
        let val: string = '';
        value.forEach((element) => {
          val += capitalizar(element) + ' ';
        });
        user[key] = val.replace(/\s*$/, '');
      }
    }
    return user;
  }
}
